import { render, staticRenderFns } from "./NewAddModel.vue?vue&type=template&id=18cc677d"
import script from "./NewAddModel.vue?vue&type=script&lang=js"
export * from "./NewAddModel.vue?vue&type=script&lang=js"
import style0 from "./NewAddModel.vue?vue&type=style&index=0&id=18cc677d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports